import React from 'react';

export const OneStopShop = [
	{
		id: 2,
		type: 'multicolumn',
		paragraphs: [
			{
				id: 21,
				paragraph: [
					<p>
						Understanding the diverse needs of investors across the country, we
						offer a wide range of investment products to our customers.
					</p>,
					<p>
						The foremost of our products is the Direct Investment Plan for
						mutual funds. These provide substantial saving on expenses that get
						paid out to mutual fund distributors in the form of distribution
						costs, trail fees, commissions, etc. The lesser expense ratio in
						Direct Plans yield higher returns annually and the compounding
						effect of these savings makes a significant impact on your returns!
						Our one-click switch to Direct Plans allows our customers to switch
						from their existing portfolio of Regular Plans to direct plan mutual
						funds, and earn higher returns.
					</p>,
				],
			},
			{
				id: 22,
				paragraph: [
					<p>
						Among our other investment opportunities, investors can choose from
						corporate fixed deposits, NPS, Bonds, Instacash, and more. Investors
						who wish to explore cross-border investment options can benefit from
						our international stock trading services that give them access to
						trade in 125 countries. For those with bigger appetites, our
						offerings include AIF and PMS. For HNI’s we provide recommendations
						for optimising return on investments by periodically analysing and
						reviewing investment portfolios and related financial goals.
					</p>,
					<p>
						We also offer solutions to corporates who want efficient management
						of their corporate treasury and working capital requirements.
					</p>,
				],
			},
		],
	},
	{
		id: 3,
		paragraphs:
			'Our B2B vertical caters to companies who want to run their own wealth management platforms by offering white label solutions.',
	},
];
